import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Pageable,
  PaymentMethodFilterSpec,
  ListPaymentMethodFilterSpec,
  WrapperPageableResponse
} from './service-common';
import type { PaymentMethodDTO } from '../core/models';

export type WrapperPageableResponsePaymentMethodDTO = WrapperPageableResponse<PaymentMethodDTO>;

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  searchPaymentMethods(
    spec: PaymentMethodFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponsePaymentMethodDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(s => params = params.append('sort', s));
    }
    return this.http.get<WrapperPageableResponsePaymentMethodDTO>(`${this.apiUrl}/payment-methods`, { params });
  }

  listPaymentMethods(
    spec: ListPaymentMethodFilterSpec = {},
    pageable: Pageable = { page: 0, size: 500 }
  ): Observable<WrapperPageableResponsePaymentMethodDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(s => params = params.append('sort', s));
    }
    return this.http.get<WrapperPageableResponsePaymentMethodDTO>(`${this.apiUrl}/payment-methods/list`, { params });
  }
}
